import { render, staticRenderFns } from "./partner-apply.vue?vue&type=template&id=b8c55e54"
import script from "./partner-apply.vue?vue&type=script&lang=js"
export * from "./partner-apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports